import ApiConstant from "../../constants/api.constants";
import { Category, CreateRawMaterialPurchaseRequest, PaginatedRawMaterialPurchaseDTO, RawMaterialPurchaseFilterDTO } from "../../models/RawMaterials/RawMaterial-model";
import Helpers from "../../utils/helpers";
import api from "../api";
import {RawMaterialPurchaseFilterExportDTO} from "../../models/RawMaterials/RawMaterial-model";

export const getVendorList = async () => {

  try {
    const result = await api.get(ApiConstant.GetVendorList)
      .then((response: any) => {
        if (response) return response.data;
        else return null;
      })
      .catch((error: any) => {
        console.error('Error reading vendor list.', error);
      });

    const response = result !== null ? result : null;
    return response;
  } catch (e) {
    console.log('Error in getVendorList API.');
    return [];
  }
};


export const getRawMaterials = async () => {

  try {
   
    const result = await api.get(ApiConstant.GetRawMaterials)
      .then((response: any) => {
        if (response) return response.data;
        else return null;
      })
      .catch((error: any) => {
        console.error('Error reading vendor list.', error);
      });

    const response = result !== null ? result : null;
    return response;
  } catch (e) {
    console.log('Error in getVendorList API.');
    return [];
  }
};




export const getRawMaterialCategories = async (materialId: number) => {

    try {
        const response = await api.get(`${ApiConstant.GetRawMaterialCategory}${materialId}`);
   
        if (response && response.data) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.error('Error fetching raw material category:', error);
        return null;
    }
};
export const getRawMaterialMeasurementype = async (materialId: number) => {
    try {
        const response = await api.get(`${ApiConstant.GetRawMaterialMeasurementtype}${materialId}`);
        console.log(ApiConstant.GetRawMaterialMeasurementtype)
        if (response && response.data) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.error('Error fetching raw material category:', error);
        return null;
    }
};

export async function createRawMaterialPurchase(payload: CreateRawMaterialPurchaseRequest) {
  try {
    // Add content-type header if not globally set
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };
    
    const response = await api.post(ApiConstant.CreateRawMaterialPurchase, payload, config);
    return response;
  } catch (err: any) {
    // More detailed error parsing
    const errorMessage = err.response?.data?.message || 
                        err.response?.data?.errors?.join(', ') || 
                        err.message;
    throw new Error(errorMessage);
  }
}

export const getRawMaterialPurchases = async (
  filter: RawMaterialPurchaseFilterDTO
): Promise<PaginatedRawMaterialPurchaseDTO & { qcStatuses?: any[] }> => {
  try {
    const hasFilters =
      (filter.rawMaterialId !== null && filter.rawMaterialId !== undefined) ||
      (filter.rmCategoryId !== null && filter.rmCategoryId !== undefined);

    const payload = {
      pageNumber: filter.pageNumber,
      pageSize: filter.pageSize,
      sortDirection: filter.sortDirection,
      sortColumn: filter.sortColumn,
      keyword: filter.keyword,
      invoiceNumber: filter.invoiceNumber,
      ...(hasFilters && {
        rawMaterialId: filter.rawMaterialId,
        rmCategoryId: filter.rmCategoryId,
      }),
      ...(filter.startDate && { startDate: filter.startDate }),
      ...(filter.endDate && { endDate: filter.endDate }),
    };

    const response = await api.post(ApiConstant.GetRawMaterialPurchase, payload);

    const data = response?.data || {};

    return {
      totalRecords: data.totalRecords ?? 0,
      rawMaterialPurchases: data.rawMaterialPurchases ?? [],
      qcStatuses: data.qcStatuses ?? [],
    };
  } catch (error) {
    console.error("Error fetching raw material purchases:", error);
    return {
      totalRecords: 0,
      rawMaterialPurchases: [],
      qcStatuses: [],
    };
  }
};
export const RMCategories = async () => {

  try {
   
    const result = await api.get(ApiConstant.GetRMCategory)
      .then((response: any) => {
        if (response) return response.data;
        else return null;
      })
      .catch((error: any) => {
        console.error('Error reading vendor list.', error);
      });

    const response = result !== null ? result : null;
    return response;
  } catch (e) {
    console.log('Error in getVendorList API.');
    return [];
  }
};
export const getQualityChecksByPurchaseId = async (rawMaterialPurchaseId: number) => {
    try {
        const response = await api.get(`${ApiConstant.GetRawmaterialQualitycheck}${rawMaterialPurchaseId}`);
        
        if (response && response.data) {
            return response.data;
        }
        return null;
    } catch (error) {
        console.error('Error fetching quality checks by purchase ID:', error);
        return null;
    }
};

const saveQualityCheckResults = async (qualityChecks: any) => {
  return await api
    .post(ApiConstant.SaveRawMaterialQCResult, qualityChecks, {
      headers: {
        "content-type": "application/json",
      },
    })
    .then(function (response: any) {
      if (response) {
        return response.data;
      }
    })
    .catch(function (error: any) {
      Helpers.ConsoleLog(error, "error");
      return error?.response?.data || error;
    });
};

export const getInvoicenos = async () => {
  try {
   
    const result = await api.get(ApiConstant.GetRMInvoiceNumbers)
      .then((response: any) => {
        if (response) return response.data;
        else return null;
      })
      .catch((error: any) => {
        console.error('Error reading vendor list.', error);
      });

    const response = result !== null ? result : null;
    return response;
  } catch (e) {
    console.log('Error in getVendorList API.');
    return [];
  }
};

const getAllRawMaterials = async () => {  
    try {
        const result: any = await api.get(ApiConstant.GetAllRawmaterial);
        if (result && result.data) {
            return {
                data: result.data.data,          // array of raw materials
                totalRecords: result.data.totalRecords // total count
            };
        }
        return { data: [], totalRecords: 0 };
    } catch (error) {
        console.error('Error in getAllRawMaterials', error);
        return { data: [], totalRecords: 0 };
    }
};

const addRawMaterial = async (rawMaterial: any) => {
  try {
    const addRawMaterial: any = await api
      .post(ApiConstant.createRawMaterial, rawMaterial)
      .then((result: any) => {
        if (result) 
          return result.data;
        else 
          return null;
      })
      .catch(function (error: any) {
        console.error("Error creating raw material.", error);
      });

    const response = addRawMaterial != null ? addRawMaterial : null;
    return response;
  } catch {
    console.log("Error in add raw material");
    return [];
  }
};
const updateRawMaterial = async (data: any) => {
  try {
    const res: any = await api
      .put(ApiConstant.UpdateRawMaterial, data)   
      .then((result: any) => {
        if (result) 
          return result.data;
        else 
          return null;
      })
      .catch(function (error: any) {
        console.error("Error updating raw material", error);
      });

    const response = res != null ? res : null;
    return response;
  } catch {
    console.log("Error in update raw material");
    return [];
  }
};


const deleteRawMaterial = async (rawMaterialId: number) => {
  try {
    const response = await api
      .delete(`${ApiConstant.deleteRawMaterial}?rawMaterialId=${rawMaterialId}`) 
      .then((res: any) => {
        if (res && res.status === 200) {
          return true;
        } else {
          return false;
        }
      })
      .catch((error: any) => {
        console.error("Error deleting raw material:", error);
        return false;
      });

    return response;
  } catch (e) {
    console.log("Error in delete raw material", e);
    return false;
  }
};


export const RMMeasurementtypes = async () => {

  try {
   
    const result = await api.get(ApiConstant.GetAllRMMeasurementtype)
      .then((response: any) => {
        if (response) return response.data;
        else return null;
      })
      .catch((error: any) => {
        console.error('Error reading vendor list.', error);
      });

    const response = result !== null ? result : null;
    return response;
  } catch (e) {
    console.log('Error in getVendorList API.');
    return [];
  }
};


const getAllRMCategories = async (request: { pageNo: number; pageSize: number; searchText?: string }) => {
  try {
    const categories: any = await api
      .post(ApiConstant.GetAllRMcategories, request)
      .then((result: any) => result?.data || null)
      .catch((error: any) => {
        console.error("Error reading RM Categories data.", error);
      });
    return categories;
  } catch (e) {
    console.error("Error in getAllRMCategories", e);
    return null;
  }
};

const deleteRMcategory = async (categoryId: number) => {
  try {
    const response = await api
      .delete(`${ApiConstant.DeleteRawMaterialCategory}?categoryId=${categoryId}`) 
      .then((res: any) => {
        if (res && res.status === 200) {
          return true;
        } else {
          return false;
        }
      })
      .catch((error: any) => {
        console.error("Error deleting category:", error);
        return false;
      });

    return response;
  } catch (e) {
    console.log("Error in delete category", e);
    return false;
  }
};

const updateRawMaterialCategory = async (data: any) => {
  try {
    const res: any = await api
      .put(ApiConstant.UpdateRawMaterialCategory, data)   
      .then((result: any) => {
        if (result) 
          return result.data;
        else 
          return null;
      })
      .catch(function (error: any) {
        console.error("Error updating raw material Category", error);
      });

    const response = res != null ? res : null;
    return response;
  } catch {
    console.log("Error in update raw material");
    return [];
  }
};

const addRawMaterialCategory = async (rawMaterialCategory: any) => {

  try {
    const addRawMaterial: any = await api
      .post(ApiConstant.CreateRawMaterialCategory, rawMaterialCategory)
      .then((result: any) => {
        if (result) 
          return result.data;
        else 
          return null;
      })
      .catch(function (error: any) {
        console.error("Error creating raw material.", error);
      });

    const response = addRawMaterial != null ? addRawMaterial : null;
    return response;
  } catch {
    console.log("Error in add raw material");
    return [];
  }
};

export const GetManufacrturingunitlist = async () => {  
    try {
        const list: any = await api
        .get(ApiConstant.GetManufacrturingunitlist)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error  get GeManufacrturing unit list.', error);
         });
        const response = list != null ? list : null;        
        return response;
    }
    catch (e) {
        console.log('error  get GeManufacrturing unit list.');
        return [];
    } 
};

export const GetposRawmaterials = async (PosID: number) => {
    try {
        const Invoice = await api.get(ApiConstant.GetposRawmaterials + PosID)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading POS raw materials list data.', error);
         });
         const response = Invoice != null ? Invoice : null;        
         return response;
    } catch (e) {
        console.log('error reading POS raw materials list data.');
        return [];
    } 
};


export const GetRemainingposRawMaterials = async (PosID: number) => {
    try {
        const Invoice = await api.get(ApiConstant.GetRemainingposRawMaterials + PosID)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error reading POS raw materials list data.', error);
         });
         const response = Invoice != null ? Invoice : null;        
         return response;
    } catch (e) {
        console.log('error reading POS raw materials list data.');
        return [];
    } 
};

const AddposRawmaterials = async (data: any) => {
    try {
        const updateproducts: any = await api
        .post(ApiConstant.AddposRawmaterials, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error adding pos RawMaterails', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error adding pos RawMaterails');
        return false;
    }
}


const UpdateposRawmaterials = async (data: any) => {
    try {
        const updateproducts: any = await api
        .put(ApiConstant.UpdateposRawmaterials, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error updating pos Raw Materials', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error updating pos Raw Materials');
        return false;
    }
}


const GetalloutwardsourceType = async () => {  
    try {
        const list: any = await api
        .get(ApiConstant.GetalloutwardsourceType)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error  get outward sourcetype.', error);
         });
        const response = list != null ? list : null;        
        return response;
    }
    catch (e) {
        console.log('error  get outward sourcetype.');
        return [];
    } 
};

export const GetRemainingMFPOS = async (PosID: number) => {
    try {
        const Invoice = await api.get(ApiConstant.GetRemainingMFPOS + PosID)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error getting remaining POS', error);
         });
         const response = Invoice != null ? Invoice : null;        
         return response;
    } catch (e) {
        console.log('error getting remaining POS');
        return [];
    } 
};


const GetVendorandInvoiceWiseQty = async (data: any) => {
  debugger
    try {
        const invoiceqty: any = await api
        .post(ApiConstant.GetVendorandInvoiceWiseQty, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error adding pos RawMaterails', error);
         });
        const response = invoiceqty != null ? invoiceqty : null;        
        return response;
    }
    catch
    {
        console.log('error adding pos RawMaterails');
        return false;
    }
}


const AddRawMaterialOutward = async (data: any) => {
  debugger
    try {
        const updateproducts: any = await api
        .post(ApiConstant.AddRawMaterialOutward, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error adding outward product', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error adding outward product');
        return false;
    }
}

const GetRMAdjustSourcetype = async () => {  
    try {
        const list: any = await api
        .get(ApiConstant.GetRMAdjustSourcetype)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error  get Adjust sourcetype.', error);
         });
        const response = list != null ? list : null;        
        return response;
    }
    catch (e) {
        console.log('error  get adjust sourcetype.');
        return [];
    } 
};

const AddRawMaterialAdjust = async (data: any) => {
  debugger
    try {
        const updateRawMaterial: any = await api
        .post(ApiConstant.AddRawMaterialAdjust, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error adding Adjust RawMaterials', error);
         });
        const response = updateRawMaterial != null ? updateRawMaterial : null;        
        return response;
    }
    catch
    {
        console.log('error adding Adjust RawMaterials');
        return false;
    }
}

const AddRawMaterialRequest = async (data: any) => {
    try {
        const updateproducts: any = await api
        .post(ApiConstant.AddRawMaterialRequest, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error requesting Raw Material', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error requesting Raw Material');
        return false;
    }
}

const GetRawMaterialOutwardRequests = async (PosID: number) => {
    try {
        const request = await api.get(ApiConstant.GetRawMaterialOutwardRequests + PosID)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error getting Raw Material request.', error);
         });
         const response = request != null ? request : null;        
         return response;
    } catch (e) {
        console.log('error getting Raw Material request');
        return [];
    } 
};

const updateRawMaterialRequestSend = async (data: any) => {
    try {
        const updateRawMaterial: any = await api
        .put(ApiConstant.updateRawMaterialRequestSend, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error updating RawMaterial status ', error);
         });
        const response = updateRawMaterial != null ? updateRawMaterial : null;        
        return response;
    }
    catch
    {
        console.log('error updating RawMaterial status');
        return false;
    }
}

const updateRawMaterialRequestReject = async (data: any) => {
    try {
        const updateRawMaterial: any = await api
        .put(ApiConstant.updateRawMaterialRequestReject, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error updating RawMaterial status ', error);
         });
        const response = updateRawMaterial != null ? updateRawMaterial : null;        
        return response;
    }
    catch
    {
        console.log('error updating RawMaterial status');
        return false;
    }
}

const GetRawMaterialInwardRequests = async (PosID: number) => {
    try {
        const request = await api.get(ApiConstant.GetRawMaterialInwardRequests + PosID)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error getting Raw Material request.', error);
         });
         const response = request != null ? request : null;        
         return response;
    } catch (e) {
        console.log('error getting Raw Material request');
        return [];
    } 
};

const updateRawMaterialInwardAccept = async (data: any) => {
    try {
        const updateRawMaterial: any = await api
        .put(ApiConstant.updateRawMaterialInwardAccept, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error updating RawMaterial status ', error);
         });
        const response = updateRawMaterial != null ? updateRawMaterial : null;        
        return response;
    }
    catch
    {
        console.log('error updating RawMaterial status');
        return false;
    }
}

const GetRawMaterialMovementLog = async (data: any) => {

    try {
        const updateproducts: any = await api
        .post(ApiConstant.GetRawMaterialMovementLog, data)
        .then((result: any)=> {
            if(result)            
                return result.data;
            else
                return null;         
         })
         .catch(function (error: any) {
             console.error('error Getting movements record', error);
         });
        const response = updateproducts != null ? updateproducts : null;        
        return response;
    }
    catch
    {
        console.log('error Getting movements record');
        return false;
    }
}


const GetRawMaterialStockSummary = async (data: any) => {
        try {
            const updateproducts: any = await api
            .post(ApiConstant.GetRawMaterialStockSummary, data)
            .then((result: any)=> {
                if(result)            
                    return result.data;
                else
                    return null;         
            })
            .catch(function (error: any) {
                console.error('error Getting summary record', error);
            });
            const response = updateproducts != null ? updateproducts : null;        
            return response;
        }
        catch
        {
            console.log('error Getting summary record');
            return false;
        }
    }

export const SaveQualityCheckResultsofRejected = async (payload: any) => {
  try {
    const response = await api.post("/api/RawMaterials/Save", payload, {
      headers: { "Content-Type": "application/json" },
    });
    return response.data;
  } catch (err: any) {
    Helpers.ConsoleLog(err, "error");
    return err?.response?.data || { isSuccess: false || "Save failed" };
  }
};


export const getRawMaterialPurchasesExport = async (
  filter: RawMaterialPurchaseFilterExportDTO
): Promise<PaginatedRawMaterialPurchaseDTO & { qcStatuses?: any[] }> => {
  try {
    const hasFilters =
      (filter.rawMaterialId !== null && filter.rawMaterialId !== undefined) ||
      (filter.rmCategoryId !== null && filter.rmCategoryId !== undefined);

    const payload = {
      sortDirection: filter.sortDirection,
      sortColumn: filter.sortColumn,
      keyword: filter.keyword,
      invoiceNumber: filter.invoiceNumber,
      ...(hasFilters && {
        rawMaterialId: filter.rawMaterialId,
        rmCategoryId: filter.rmCategoryId,
      }),
      ...(filter.startDate && { startDate: filter.startDate }),
      ...(filter.endDate && { endDate: filter.endDate }),
    };

    const response = await api.post(ApiConstant.GetRawMaterialPurchaseExport, payload);
    const data = response?.data || {};
    return {
      totalRecords: data.totalRecords ?? 0,
      rawMaterialPurchases: data.rawMaterialPurchases ?? [],
      qcStatuses: data.qcStatuses ?? [],
    };
  } catch (error) {
    console.error("Error fetching raw material purchases:", error);
    return {
      totalRecords: 0,
      rawMaterialPurchases: [],
      qcStatuses: [],
    };
  }
};

export const getRawMaterialPurchaseSummary = async (filter: {
  posIds: number[];
  rawMaterialIds?: number[] | null;
  pageNumber?: number;
  pageSize?: number;
  sortField?: string | null;
  sortOrder?: string | null;
}): Promise<{
  totalRecords: number;
  data: any[];
  posTotals: { posId: number; posCode: string; totalInventoryValue: number }[];
}> => {
  try {
    const payload = {
      posIds: filter.posIds ?? [],
      rawMaterialIds: filter.rawMaterialIds ?? [],
      pageNumber: filter.pageNumber ?? 1,
      pageSize: filter.pageSize ?? 10,
      sortField: filter.sortField ?? null,
      sortOrder: filter.sortOrder ?? null,
    };
    
    const response = await api.post(ApiConstant.GetRawmaterialReport, payload);
    const data = response?.data || {};

    return {
      totalRecords: data.totalRecords ?? 0,
      data: data.data ?? [],
      posTotals: data.posTotals ?? [],
    };
  } catch (error) {
    console.error("Error fetching Raw Material Inventory Value Summary:", error);
    return {
      totalRecords: 0,
      data: [],
      posTotals: [], 
    };
  }
};

export const getRawMaterialReportTotalInventory = async (filter: {
  posIds: number[];
}): Promise<{
  posTotals: { posId: number; posCode: string; totalInventoryValue: number }[];
  reportGenerated?: string;
  note?: string;
}> => {
  try {
    const payload = {
      posIds: filter.posIds ?? [],
    };

    const response = await api.post(ApiConstant.GetRawmaterialReportTotalInventory, payload);
    const data = response?.data || {};

    return {
      posTotals: data.posTotals ?? [],
    };
  } catch (error) {
    console.error("Error fetching POS total inventory summary:", error);
    return {
      posTotals: [],
    };
  }
};

export const getRawMaterialReportExport = async (filter: {
  posIds: number[];
  rawMaterialIds?: number[] | null;
}): Promise<any> => {
  try {
    const payload = {
      posIds: filter.posIds ?? [],
      rawMaterialIds: filter.rawMaterialIds ?? null,
    };

    const response = await api.post(ApiConstant.GetRawmaterialReportExport, payload);
    return response.data;
  } catch (error) {
    console.error("Error exporting raw material report:", error);
    throw error;
  }
};

export const getRawMaterialByPosId = async (filter: {
  posIds: number[];
}): Promise<any> => {
  try {
    const payload = {
      posIds: filter.posIds ?? [],
    };
    const response = await api.post(ApiConstant.GetRawMaterialsByPosid, payload);
    return response.data;
  } catch (error) {
    console.error("Error getting the raw materials:", error);
    throw error;
  }
};

export const getRawMaterialUtilizationSummary = async (filter: {
  posIds?: number[] | null;
  vendorId?: number | null;
  rawMaterialIds?: number[] | null;
  startDate?: string | null;
  endDate?: string | null;
  minUtilizedQty?: number | null;
  maxUtilizedQty?: number | null;
  pageNumber?: number;
  pageSize?: number;
  sortBy?: string | null;
  sortDirection?: string | null;
}): Promise<{
  totalRecords: number;
  maxUtilizedQuantity: number;
  data: {
    id: number;
    posId: number;
    vendorId: number;
    rawMaterialId: number;
    invoiceNumber: string;
    purchaseDate: string;
    invoicedQuantity: number;
    basicAmount: number;
    taxAmount: number;
    totalAmount: number;
    acceptedQuantity: number | null;
    rejectedQuantity: number;
    utilizedQuantity: number;
    utilizedQuantityDisplay: string; 
    remainingQty: number;
    invoicedRemainingQty:number;
    acceptedRemainingQty:number
    vendorName: string;
    rawMaterialName: string;
    posAddress: string;
  }[];
}> => {
  try {
    const payload = {
      posIds: filter.posIds ?? [],
      vendorId: filter.vendorId ?? null,
      rawMaterialIds: filter.rawMaterialIds ?? [],
      startDate: filter.startDate ?? null,
      endDate: filter.endDate ?? null,
      minUtilizedQty: filter.minUtilizedQty ?? null,
      maxUtilizedQty: filter.maxUtilizedQty ?? null,
      pageNumber: filter.pageNumber ?? 1,
      pageSize: filter.pageSize ?? 10,
      sortBy: filter.sortBy ?? null,
      sortDirection: filter.sortDirection ?? null,
    };

    const response = await api.post(ApiConstant.GetRawMaterialPurchaseHistory, payload);
    const data = response?.data || {};

    return {
      totalRecords: data.totalRecords ?? 0,
      data: data.data ?? [],
      maxUtilizedQuantity: data.maxUtilizedQuantity ?? 0,
    };
  } catch (error) {
    console.error("Error fetching raw material utilization summary:", error);
    return {
      totalRecords: 0,
      data: [],
      maxUtilizedQuantity: 0,
    };
  }
};

export const getRawMaterialUtilizationSummaryExport = async (filter: {
  posIds?: number[] | null;
  vendorId?: number | null;
  rawMaterialIds?: number[] | null;
  startDate?: string | null;
  endDate?: string | null;
  minUtilizedQty?: number | null;
  maxUtilizedQty?: number | null;
  sortBy?: string | null;
  sortDirection?: string | null;
}): Promise<{
  data: {
    id: number;
    posId: number;
    vendorId: number;
    rawMaterialId: number;
    invoiceNumber: string;
    purchaseDate: string;
    invoicedQuantity: number;
    basicAmount: number;
    taxAmount: number;
    totalAmount: number;
    acceptedQuantity: number | null;
    rejectedQuantity: number;
    utilizedQuantity: number;
    utilizedQuantityDisplay: string;
    invoicedRemainingQty: number;
    acceptedRemainingQty: number;
    vendorName: string;
    rawMaterialName: string;
    posAddress: string;
  }[];
}> => {
  try {
    const payload = {
      posIds: filter.posIds ?? [],
      vendorId: filter.vendorId ?? null,
      rawMaterialIds: filter.rawMaterialIds ?? [],
      startDate: filter.startDate ?? null,
      endDate: filter.endDate ?? null,
      minUtilizedQty: filter.minUtilizedQty ?? null,
      maxUtilizedQty: filter.maxUtilizedQty ?? null,
      sortBy: filter.sortBy ?? null,
      sortDirection: filter.sortDirection ?? null,
    };

    const response = await api.post(ApiConstant.GetRawMaterialPurchaseHistoryExport, payload);

    const data = response?.data || [];

    return {
      data: Array.isArray(data) ? data : [],
    };
  } catch (error) {
    console.error("Error fetching raw material utilization export:", error);
    return {
      data: [],
    };
  }
};

const RawMaterialService = {
    getVendorList,
    getRawMaterialCategories,
    getRawMaterials,
     createRawMaterialPurchase,
     getRawMaterialPurchases,
     RMCategories,
     getQualityChecksByPurchaseId,
     saveQualityCheckResults,
     getInvoicenos,
     getAllRawMaterials,
     addRawMaterial,
     updateRawMaterial,
     deleteRawMaterial,
     RMMeasurementtypes,
     getAllRMCategories,
     deleteRMcategory,
     updateRawMaterialCategory,
     addRawMaterialCategory,
     GetManufacrturingunitlist,
     GetposRawmaterials,
     GetRemainingposRawMaterials,
     AddposRawmaterials,
     UpdateposRawmaterials,
     GetalloutwardsourceType,
     GetRemainingMFPOS,
     GetVendorandInvoiceWiseQty,
     AddRawMaterialOutward,
     GetRMAdjustSourcetype,
     AddRawMaterialAdjust,
     AddRawMaterialRequest,
     GetRawMaterialOutwardRequests,
     updateRawMaterialRequestSend,
     updateRawMaterialRequestReject,
     GetRawMaterialInwardRequests,
     updateRawMaterialInwardAccept,
     GetRawMaterialMovementLog,
     GetRawMaterialStockSummary,
    SaveQualityCheckResultsofRejected,
    getRawMaterialPurchaseSummary,
    getRawMaterialReportTotalInventory,
    getRawMaterialReportExport
    
}
export default RawMaterialService;